<div class="profile-image p-col-12" style="max-width:225px;">
  <div class="profile-back">
    <img id="userPhoto" style="border: 0px;max-width:200px;" src="">
  </div>
  <p-fileUpload name="myfile[]" (onSelect)="onPhotoUpload($event, photo)" [maxFileSize]="maxFileSize" accept="image/*" auto="true" mode="basic" styleClass="button-action">
  </p-fileUpload>
</div>
